// extracted by mini-css-extract-plugin
export default {"root":"root-GE2sH","threeXL":"threeXL-S2MoK","fourXL":"fourXL-a5fbf","s":"s-WJJmO"};